// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"8f5fea26","453":"f85a337a","455":"3eb0179e","977":"a9fdfcbb"}[chunkId] + ".chunk.js";
};